import { render, staticRenderFns } from "./index_animal.vue?vue&type=template&id=4ab3c5d5&scoped=true&"
import script from "./index_animal.vue?vue&type=script&lang=js&"
export * from "./index_animal.vue?vue&type=script&lang=js&"
import style0 from "./index_animal.vue?vue&type=style&index=0&id=4ab3c5d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab3c5d5",
  null
  
)

export default component.exports